/*
 * The formatting the client-detail panels share.
 *
 * One module rather than a copy per panel: the day/month order below is the
 * difference between 10 August and 8 October, and two of these living in two
 * files is how a screen ends up disagreeing with the report beside it.
 */

export const message = (cause: unknown): string =>
  cause instanceof Error ? cause.message : String(cause);

export const plural = (count: number, noun: string): string =>
  `${count} ${noun}${count === 1 ? '' : 's'}`;

export const asDate = (iso: string): string => new Date(iso).toLocaleDateString('en-GB');

export const asMoment = (iso: string): string => new Date(iso).toLocaleString('en-GB');
